import { shuffle } from 'es-toolkit/compat';

export const generateMediaName = (restaurantName: string, keywords: string[], mediaOriginalName: string | null = null): string => {
    const restaurantFormattedName = restaurantName.normalize('NFD').trim().toLowerCase().replace(/\s+/g, '-');

    const NUMBER_OF_KEYWORDS_TO_USE = 2;
    const randomKeywords = shuffle(keywords).slice(0, NUMBER_OF_KEYWORDS_TO_USE);
    const formattedKeywords = randomKeywords.map((randomKeyword) => randomKeyword.replace(/\s+/g, '-')).join('-');

    return formattedKeywords.length
        ? `${restaurantFormattedName}-${formattedKeywords}`
        : (restaurantFormattedName ?? mediaOriginalName ?? '');
};
